import { useEffect, useState } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// 20221209 - spostato paypal
//import { PayPalScriptProvider } from "@paypal/react-paypal-js";
//import { PAYPAL_CLIENT_ID } from "./utils/paypalKeys";
import allActions from './state/actions';
import ScrollToTop from './hoc/ScrollToTop';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomepageRoute from './routes/homepageRoute';
import NetsRoute from './routes/netsRoute';
import ParentCategoryRoute from './routes/parentCategoryRoute';
import ParentCategoryPackageRoute from './routes/parentCategoryPackageRoute';
import CategoryRoute from './routes/categoryRoute';
import ProductRoute from './routes/productRoute';
import PackageRoute from './routes/packageRoute';
import CartRoute from './routes/cartRoute';
import RegistrationRoute from './routes/registrationRoute';
import RegistrationFormRoute from './routes/registrationFormRoute';
import PaymentRoute from './routes/paymentRoute';
import CheckoutRoute from './routes/checkoutRoute';
import ProfileRoute from './routes/profileRoute';
import AddressesRoute from './routes/addressesRoute';
import OrdersRoute from './routes/ordersRoute';
import CouponsRoute from './routes/couponsRoute';
import OrderClosedRoute from './routes/orderClosedRoute';
import ChisiamoRoute from './routes/chisiamoRoute';
import LenostreretiRoute from './routes/lenostreretiRoute';
import ContattiRoute from './routes/contattiRoute';
import ContattiokRoute from './routes/contattiokRoute';
import ContattikoRoute from './routes/contattikoRoute';
import CondizioniVenditaRoute from './routes/condizioniVenditaRoute';
import MagazineRoute from './routes/magazineRoute';
import MagazineCategoryRoute from './routes/magazineCategoryRoute';
import MagazineArticleRoute from './routes/magazineArticleRoute';
import RisultatiricercaRoute from './routes/risultatiricercaRoute';
import PrivacyPolicyRoute from './routes/privacyPolicyRoute';
import CookiesPolicyRoute from './routes/cookiesPolicyRoute';
import Error404 from './pages/error404/Error404';
import { BASENAME } from './utils/basename';
import ModalConfirm from './components/shared/modalConfirm/ModalConfirm';
import { axios } from './utils/axiosBase';

import TagManager from 'react-gtm-module';

import exitIntent from 'exit-intent';

let interval;

const App = () => {
	const dispatch = useDispatch();
	const currentPage = useSelector((state) => state.currentPage);
	const user = useSelector((state) => state.user);
	const order = useSelector((state) => state.order);
	const cart = useSelector((state) => state.cart);
	const siteParams = useSelector((state) => state.siteParams);

	const pageName = useSelector((state) => state.currentPage.pageName);

	const routeTranslation = useSelector(
		(state) => state.translations.routesTranslated,
	);
	const tokenCarrello = useSelector((state) => state.user.token_id);
	const genericheTranslation = useSelector(
		(state) => state.translations.generiche,
	);

	const timeoutexitintent = useSelector(
		(state) => state.currentPage.ipcaller.timeoutexitintent,
	);

	// local state
	const [isAuthenticating, setIsAuthenticating] = useState(false);

	// lingua corrente
	const suffissoLang = currentPage.currentLang.replace('_', '');

	const soglia_exitintent = parseFloat(siteParams?.soglia_exitintent);

	useEffect(() => {
		//console.log("APP useEffect");

		//console.log("TAG MANAGER Start");

		//console.log(user.userData);

		const gtmSuffix = `gtm_code_${suffissoLang}`;
		const gtmAuthSuffix = `gtm_auth_${suffissoLang}`;
		const gtmPreviewSuffix = `gtm_preview_${suffissoLang}`;
		const currentGTMTAG = siteParams[gtmSuffix];
		const currentGTMAUTH = siteParams[gtmAuthSuffix];
		const currentGTMPREVIEW = siteParams[gtmPreviewSuffix];

		if (
			currentGTMTAG !== null &&
			pageName !== null &&
			pageName !== undefined &&
			pageName !== ''
		) {
			//console.log("inizializzo tagManagerxx", pageName);
			let userId = '';
			if (user.isLogged && user.userData.id !== undefined) {
				userId = user.userData.id;
			}
			let tagManagerArgs = {
				gtmId: currentGTMTAG,
				auth: currentGTMAUTH,
				preview: currentGTMPREVIEW,
				dataLayer: {
					page_type: pageName,
					userId: userId,
					userProject: 'sito2021',
				},
			};
			//console.log("inizializzo tagManager");
			if (typeof window !== 'undefined') {
				TagManager.initialize(tagManagerArgs);
			}
		}
	}, [pageName]);
	useEffect(() => {
		//console.log("APP useEffect");

		//console.log("UserIsLogged " + user.isLogged);

		//if (currentPage.ipcaller.ipclientexitinfo == null && order.subtotalCart > 0) {
		if (
			currentPage.ipcaller.codicefreeexitintent != null &&
			currentPage.ipcaller.ipclientexitinfo == null &&
			currentPage.ipcaller.immagine_regalo !== undefined &&
			order.subtotalCart >= soglia_exitintent &&
			window.intentPopDone !== 1
		) {
			// Initialise ExitIntent
			//threshold (default 20) maximum distance in pixels from the top of the page to trigger.
			//maxDisplays (default 1) maximum number of times to trigger.
			// eventThrottle (default 200) event throttle in milliseconds.

			sessionStorage.setItem('exitpopupshown', true);
			window.intentPopDone = 1;

			const ConfirmOmaggio = (
				<div className='grid grid-cols-60'>
					<div className='col-span-60 md:col-span-30 flex items-stretch'>
						<picture>
							<source
								media='(min-width: 768px)'
								srcSet={`${BASENAME}${currentPage.ipcaller.immagine_regalo.fullUrl}`}
							/>
							<source
								media='(min-width: 768px)'
								srcSet={`${BASENAME}${currentPage.ipcaller.immagine_regalo.fullUrl}`}
							/>
							<source
								srcSet={`${BASENAME}${currentPage.ipcaller.immagine_regalo_mobile.fullUrl}`}
							/>
							<img
								src={`${BASENAME}${currentPage.ipcaller.immagine_regalo_mobile.fullUrl}`}
								width='500'
								height='262'
								className='img-contained'
								alt='Ribola regalo'
							/>
						</picture>
					</div>
					<div className='col-span-60 md:col-span-30'>
						<div className='text-md lg:text-3xl md:text-md p-3 text-white bg-ribola-amber font-opensansbold w-full text-center'>
							{genericheTranslation.exitintentiontext1.itemName}
						</div>
						<div className='text-md lg:text-3xl md:text-md text-ribola-congress-blue font-opensansbold w-full text-center lg:p-6 p-3'>
							{genericheTranslation.exitintentiontext2.itemName
								.replace('XX', timeoutexitintent)
								.toUpperCase()}
						</div>
						<div className='clear-both'></div>
						<div className='text-xs my-2'>
							{genericheTranslation.exitintentiontext3.itemName}
						</div>
						<div className='clear-both'></div>
						<div className='w-full px-9 m-auto'>
							<table className='w-full m-auto'>
								<thead>
									<tr>
										<td className='w-2/5 text-5xl sm:text-6xl md:text-5xl 3xl:text-6xl md:text-md font-opensansbold text-ribola-congress-blue text-center'>
											<div className='square shadow-2xl'>
												<div className='text-inside-square'>
													{currentPage.ipcaller.timeoutexitintent}
												</div>
											</div>
										</td>
										<td className='text-5xl sm:text-6xl md:text-6xl lg:text-6xl md:text-md font-opensansbold text-ribola-congress-blue text-center'>
											:
										</td>
										<td className='w-2/5 text-5xl sm:text-6xl md:text-5xl 3xl:text-6xl md:text-md font-opensansbold text-ribola-congress-blue text-center'>
											<div className='square shadow-2xl'>
												<div className='text-inside-square'>00</div>
											</div>
										</td>
									</tr>
									<tr>
										<td className='text-md lg:text-2xl md:text-md font-opensansbold text-ribola-congress-blue text-center'>
											<div>
												{genericheTranslation.exitintentionminuti.itemName.toUpperCase()}
											</div>
										</td>
										<td className='text-md lg:text-3xl md:text-md font-opensansbold text-ribola-congress-blue text-center'>
											&nbsp;
										</td>
										<td className='text-md lg:text-2xl md:text-md font-opensansbold text-ribola-congress-blue text-center'>
											<div>
												{genericheTranslation.exitintentionsecondi.itemName.toUpperCase()}
											</div>
										</td>
									</tr>
								</thead>
							</table>
						</div>
						<div className='clear-both'></div>
						<button
							type='button'
							role='button'
							className='amberButton customSwalBtnConfirm mt-4'>
							{genericheTranslation.exitintentionbtnconfirm.itemName.toUpperCase()}
						</button>
						<div className='clear-both'></div>
						<button
							type='button'
							role='button'
							className='customSwalBtnClose text-xs my-4'>
							{genericheTranslation.exitintentionbtnclose.itemName.toUpperCase()}
						</button>
					</div>
				</div>
			);
			const removeExitIntent = exitIntent({
				threshold: 20,
				maxDisplays: 1,
				eventThrottle: 100,
				onExitIntent: () => {
					console.log('exit-intent triggered');
					sessionStorage.setItem('exitpopupshown', true);

					window.intentPopDone = 1;

					ModalConfirm({
						titleToShow: '',
						messageToShow: ConfirmOmaggio,
						isShowConfirmButton: false,
						isShowCanceButton: false,
						isTimerModal: false,
						textConfirmButton: genericheTranslation.conferma.itemName,
						textCancelButton: genericheTranslation.annulla.itemName,
						customClassContainer: 'modalExitIntentRibola',
						onClickHandler: async () => {
							const payload = {
								ipcaller: currentPage.ipcaller,
								currentLang: currentPage.currentLang,
								tokenCarrello: tokenCarrello,
								userId: user,
								status: 'Acceped',
							};

							// chiamo web service
							const response = await axios.post(
								`api/storeipexitintent/`,
								payload,
								{
									withCredentials: true,
								},
							);

							// qui devo aggiungere l'articolo a carrello

							const productCart = {
								tokenCarrello: tokenCarrello,
								product_id:
									currentPage.ipcaller.productCartfrreintent.product_id,
								name: currentPage.ipcaller.productCartfrreintent.name,
								codice: currentPage.ipcaller.productCartfrreintent.codice,
								titoloCategoria:
									currentPage.ipcaller.productCartfrreintent.titoloCategoria,
								quantita:
									currentPage.ipcaller.productCartfrreintent.quantita.toString(),
								totalePrezzo:
									currentPage.ipcaller.productCartfrreintent.totalePrezzo,
								totalePrezzoOriginale:
									currentPage.ipcaller.productCartfrreintent
										.totalePrezzoOriginale,
								sconto: currentPage.ipcaller.productCartfrreintent.sconto,
								tipologia_sconto:
									currentPage.ipcaller.productCartfrreintent.tipologia_sconto,
								tipologia_sconto_msg:
									currentPage.ipcaller.productCartfrreintent
										.tipologia_sconto_msg,
								promozione3x2:
									currentPage.ipcaller.productCartfrreintent.promozione3x2,
								promozioneProdottoAbbinato:
									currentPage.ipcaller.productCartfrreintent
										.promozioneProdottoAbbinato,
								colore: currentPage.ipcaller.productCartfrreintent.colore,
								pesoCollo: currentPage.ipcaller.productCartfrreintent.pesoCollo,
								prezzoFissoObj:
									currentPage.ipcaller.productCartfrreintent.prezzoFissoObj,
								isomaggio: true,
							};

							// chiamo action creator postCartAdd
							dispatch(
								allActions.cartDetailActions.postCartAdd(
									currentPage.currentLang,
									user?.userData?.id,
									order.selectedCountryRealId,
									productCart,
								),
							);

							window.location.reload(true);
							console.log('ok');
						},
						onCancelHandler: async () => {
							const payload = {
								ipcaller: currentPage.ipcaller,
								currentLang: currentPage.currentLang,
								tokenCarrello: tokenCarrello,
								userId: user,
								status: 'Refused',
							};

							// chiamo web service
							const response = await axios.post(
								`api/storeipexitintent/`,
								payload,
								{
									withCredentials: true,
								},
							);
							console.log('ko');
						},
						onDidRender: async () => {
							const payload = {
								ipcaller: currentPage.ipcaller,
								currentLang: currentPage.currentLang,
								tokenCarrello: tokenCarrello,
								userId: user,
							};

							// chiamo web service
							const response = await axios.post(
								`api/storeipexitintent/`,
								payload,
								{
									withCredentials: true,
								},
							);
						},
					});
				},
			});
		} else {
			//console.log("no exitintent");
		}

		// authenticate user (recupero X-XSRF-TOKEN per il carrello e le chiamate successive autenticate)
		if (!currentPage.isAuthenticated && isAuthenticating === false) {
			setIsAuthenticating(true);
			dispatch(allActions.userActions.authenticateUser());
		}

		if (order.subtotalCart < soglia_exitintent && order.totalItems == 0) {
			clearInterval(interval);
			const elementToShow = document.getElementById('date-countdown-container');
			elementToShow.classList.remove('active');
		} else if (
			currentPage.ipcaller.ipclientexitinfo != null &&
			currentPage.ipcaller.codicefreeexitintent != null
		) {
			// Convert to milisecond
			const second = 1000;
			const minute = second * 60;
			const hour = minute * 60;
			const day = hour * 24;

			const dateTimeUa = currentPage.ipcaller.ipclientexitinfo.updated_at;

			let dateTimeUaParts = dateTimeUa.split(/[- :]/);
			dateTimeUaParts[1]--;
			var eventDayUa = new Date(...dateTimeUaParts);
			var eventDay = new Date(
				eventDayUa.getTime() + currentPage.ipcaller.timeoutexitintent * minute,
			);

			const todayf = new Date();
			const timeSpanf = eventDay - todayf;
			if (
				currentPage.ipcaller.ipclientexitinfo.status == 'Acceped' &&
				timeSpanf > 0
			) {
				let minuteField = document.getElementById('minute');
				let secondField = document.getElementById('second');

				const elementToShow = document.getElementById(
					'date-countdown-container',
				);

				const countDownFn = () => {
					const today = new Date();
					const timeSpan = eventDay - today;
					console.log('Order ti: ' + order.subtotalCart);
					if (order.subtotalCart < soglia_exitintent && order.totalItems == 0) {
						clearInterval(interval);

						elementToShow.classList.remove('active');
						return;
					} else if (
						order.subtotalCart < soglia_exitintent &&
						order.totalItems > 0
					) {
						clearInterval(interval);
						elementToShow.classList.remove('active');

						// chiamo action creator per rimuove articolo da carrello

						dispatch(
							allActions.cartDetailActions.deleteCartItem(
								currentPage.currentLang,
								user?.userData?.id,
								order.selectedCountryRealId,
								tokenCarrello,
								currentPage.ipcaller.productCartfrreintent.cart_id,
							),
						);

						return;
					} else if (timeSpan <= -today) {
						console.log('Unfortunately we have past the event day');
						clearInterval(interval);

						elementToShow.classList.remove('active');

						// chiamo action creator per rimuove articolo da carrello

						dispatch(
							allActions.cartDetailActions.deleteCartItem(
								currentPage.currentLang,
								user?.userData?.id,
								order.selectedCountryRealId,
								tokenCarrello,
								currentPage.ipcaller.productCartfrreintent.cart_id,
							),
						);

						return;
					} else if (timeSpan <= 0) {
						console.log('Today is the event day');
						clearInterval(interval);

						elementToShow.classList.remove('active');

						// chiamo action creator per rimuove articolo da carrello

						dispatch(
							allActions.cartDetailActions.deleteCartItem(
								currentPage.currentLang,
								user?.userData?.id,
								order.selectedCountryRealId,
								tokenCarrello,
								currentPage.ipcaller.productCartfrreintent.cart_id,
							),
						);

						return;
					} else {
						const days = Math.floor(timeSpan / day);
						const hours = Math.floor((timeSpan % day) / hour);
						const minutes = Math.floor((timeSpan % hour) / minute);
						const seconds = Math.floor((timeSpan % minute) / second);
						sessionStorage.setItem('exitpopupshownminutes', minutes);
						sessionStorage.setItem('exitpopupshownseconds', seconds);

						minuteField.innerHTML = minutes;
						secondField.innerHTML = seconds;
						elementToShow.classList.add('active');

						const cart_id_omaggio =
							currentPage.ipcaller.productCartfrreintent.cart_id;

						if (cart[cart_id_omaggio] == undefined) {
							const productCart = {
								tokenCarrello: tokenCarrello,
								product_id:
									currentPage.ipcaller.productCartfrreintent.product_id,
								name: currentPage.ipcaller.productCartfrreintent.name,
								codice: currentPage.ipcaller.productCartfrreintent.codice,
								titoloCategoria:
									currentPage.ipcaller.productCartfrreintent.titoloCategoria,
								quantita:
									currentPage.ipcaller.productCartfrreintent.quantita.toString(),
								totalePrezzo:
									currentPage.ipcaller.productCartfrreintent.totalePrezzo,
								totalePrezzoOriginale:
									currentPage.ipcaller.productCartfrreintent
										.totalePrezzoOriginale,
								sconto: currentPage.ipcaller.productCartfrreintent.sconto,
								tipologia_sconto:
									currentPage.ipcaller.productCartfrreintent.tipologia_sconto,
								tipologia_sconto_msg:
									currentPage.ipcaller.productCartfrreintent
										.tipologia_sconto_msg,
								promozione3x2:
									currentPage.ipcaller.productCartfrreintent.promozione3x2,
								promozioneProdottoAbbinato:
									currentPage.ipcaller.productCartfrreintent
										.promozioneProdottoAbbinato,
								colore: currentPage.ipcaller.productCartfrreintent.colore,
								pesoCollo: currentPage.ipcaller.productCartfrreintent.pesoCollo,
								prezzoFissoObj:
									currentPage.ipcaller.productCartfrreintent.prezzoFissoObj,
								isomaggio: true,
							};

							// chiamo action creator postCartAdd
							dispatch(
								allActions.cartDetailActions.postCartAdd(
									currentPage.currentLang,
									user?.userData?.id,
									order.selectedCountryRealId,
									productCart,
								),
							);
						}
					}
				};

				console.log(order);
				if (order.subtotalCart < soglia_exitintent && order.totalItems == 0) {
					clearInterval(interval);
					elementToShow.classList.remove('active');
					return;
				} else {
					interval = setInterval(countDownFn, second);
				}
			}
		}
		return () => {
			clearInterval(interval);
		};
	}, [currentPage, order, cart, user]);

	// opzione configurazione Stripe
	const CustomFontSourceObj = {
		family: 'OpenSansRegular',
		src: 'url(/webfonts/OpenSans-Regular.woff2)',
		weight: '400',
		display: 'swap',
	};

	return (
		<ScrollToTop>
			<Header />
			<Switch>
				{HomepageRoute}
				{ContattiRoute(routeTranslation.contattiroute[suffissoLang])}
				{ContattiokRoute(routeTranslation.contattiokroute[suffissoLang])}
				{ContattikoRoute(routeTranslation.contattikoroute[suffissoLang])}
				{ChisiamoRoute(routeTranslation.chisiamoroute[suffissoLang])}
				{LenostreretiRoute(routeTranslation.lenostreretiroute[suffissoLang])}
				{CondizioniVenditaRoute(
					routeTranslation.condizionivenditaroute[suffissoLang],
				)}
				{PrivacyPolicyRoute(routeTranslation.privacypolicyroute[suffissoLang])}
				{CookiesPolicyRoute(routeTranslation.cookiespolicyroute[suffissoLang])}
				{RisultatiricercaRoute(routeTranslation.searchroute[suffissoLang])}
				{MagazineRoute(routeTranslation.magazineroute[suffissoLang])}
				{MagazineCategoryRoute(routeTranslation.magazineroute[suffissoLang])}
				{MagazineArticleRoute(routeTranslation.magazineroute[suffissoLang])}
				{CartRoute(routeTranslation.carrelloroute[suffissoLang])}
				<OrderClosedRoute exact path='/stripe-ok.html' key='orderStripeRoute' />
				<OrderClosedRoute exact path='/paypal-ok.html' key='orderStripeRoute' />
				<OrderClosedRoute
					exact
					path='/bonifico-ok.html'
					key='orderBonificoRoute'
				/>
				<OrderClosedRoute exact path='/riba-ok.html' key='orderRibaRoute' />
				<OrderClosedRoute
					exact
					path='/contrassegno-ok.html'
					key='orderContrassegnoRoute'
				/>
				<PaymentRoute
					exact
					path={`/${routeTranslation.pagamentoroute[suffissoLang]}.html`}
					key={`${routeTranslation.pagamentoroute[suffissoLang]}Route`}
					isLogged={user.isLogged}
					orderItems={order.totalItems}
				/>
				<CheckoutRoute
					exact
					path={`/${routeTranslation.concludiordineroute[suffissoLang]}.html`}
					key={`${routeTranslation.concludiordineroute[suffissoLang]}Route`}
					isLogged={user.isLogged}
					addressId={order.addressId}
					paymentId={order.paymentId}
					userId={order.userId}
					orderItems={order.totalItems}
					isNoShipping={order.isNoShipping}
				/>
				{NetsRoute(routeTranslation.retiroute[suffissoLang])}
				{ParentCategoryPackageRoute(routeTranslation.retiroute[suffissoLang])}
				{ParentCategoryRoute(routeTranslation.retiroute[suffissoLang])}
				{CategoryRoute(routeTranslation.retiroute[suffissoLang])}
				{PackageRoute(routeTranslation.retiroute[suffissoLang])}
				{ProductRoute(routeTranslation.retiroute[suffissoLang])}
				<ProfileRoute
					exact
					path={`/${routeTranslation.profiloroute[suffissoLang]}.html`}
					key={`${routeTranslation.profiloroute[suffissoLang]}Route`}
					isLogged={user.isLogged}
				/>
				<AddressesRoute
					exact
					path={`/${routeTranslation.indirizziroute[suffissoLang]}.html`}
					key={`${routeTranslation.indirizziroute[suffissoLang]}Route`}
					isLogged={user.isLogged}
				/>
				<OrdersRoute
					exact
					path={`/${routeTranslation.ordiniroute[suffissoLang]}.html`}
					key={`${routeTranslation.ordiniroute[suffissoLang]}Route`}
					isLogged={user.isLogged}
				/>
				<CouponsRoute
					exact
					path={`/${routeTranslation.couponsroute[suffissoLang]}.html`}
					key={`${routeTranslation.couponsroute[suffissoLang]}Route`}
					isLogged={user.isLogged}
				/>
				<RegistrationRoute
					exact
					path={`/${routeTranslation.registrazioneroute[suffissoLang]}.html`}
					key={`${routeTranslation.registrazioneroute[suffissoLang]}Route`}
					isLogging={currentPage.isLogging}
					isLogged={user.isLogged}
				/>
				<RegistrationFormRoute
					exact
					path={`/${routeTranslation.registrazioneformroute[suffissoLang]}.html`}
					key={`${routeTranslation.registrazioneformroute[suffissoLang]}Route`}
					isLogged={user.isLogged}
					redirectPage={
						order.totalItems > 0
							? routeTranslation.pagamentoroute[suffissoLang]
							: routeTranslation.profiloroute[suffissoLang]
					}
				/>
				<Route exact path='/*' component={Error404} key='404Route' />
			</Switch>
			<Footer />
		</ScrollToTop>
	);
};

export default withRouter(App);
